document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cart-drawer-upsell-add]');
  if (!button) return;

  const variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;

  button.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status) {
        console.warn(data.description || data.message);
        return;
      }
      const targets = {
        'cart-drawer': { elementId: 'CartDrawer', selector: '.drawer__inner' },
        'cart-icon-bubble': { elementId: 'cart-icon-bubble', selector: '.shopify-section' },
      };
      Object.keys(targets).forEach((id) => {
        const html = data.sections && data.sections[id];
        if (!html) return;
        const { elementId, selector } = targets[id];
        const container = document.getElementById(elementId);
        if (!container) return;
        const target = container.querySelector(selector) || container;
        const fragment = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        if (fragment) target.innerHTML = fragment.innerHTML;
      });
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && !cartDrawer.classList.contains('active')) cartDrawer.open();
    })
    .catch((error) => console.warn(error))
    .finally(() => {
      button.disabled = false;
    });
});
